import { render, staticRenderFns } from "./DossierIntegrationForm.vue?vue&type=template&id=696982c2&scoped=true"
import script from "./DossierIntegrationForm.vue?vue&type=script&lang=ts"
export * from "./DossierIntegrationForm.vue?vue&type=script&lang=ts"
import style0 from "./DossierIntegrationForm.vue?vue&type=style&index=0&id=696982c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696982c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696982c2')) {
      api.createRecord('696982c2', component.options)
    } else {
      api.reload('696982c2', component.options)
    }
    module.hot.accept("./DossierIntegrationForm.vue?vue&type=template&id=696982c2&scoped=true", function () {
      api.rerender('696982c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/accountant/DossierIntegrationForm.vue"
export default component.exports